// Centralized site URL for building absolute canonical and OG image URLs
export const SITE_URL = "https://www.joeyfamily.com";
